import React, { Component } from 'react';
import { connect } from 'shalala';

import { useStore } from '../../../store';
import Loading from '../../../facturotopia/loading/Loading';
import LoadingButton from '../../../facturotopia/LoadingButton';
import ResponseError from '../../../shared/responses/ResponseError';
import EmisorPdfCustomization from './components/EmisorPdfCustomization';
import EmisorSeriesManager from '../upsert/components/EmisorSeriesManager';

class EmisorCustomization extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {
        ...props.data,
      },
    };
  }

  handleOnDataChange = (event) => {
    const { data } = this.props.customization;
    const { personalizar } = data.config || {};

    this.props.setPartialState({
      data: {
        ...data,
        config: {
          ...data.config,
          personalizar: {
            ...personalizar,
            ...event.data,
          },
        },
      },
      isValid: event.isValid,
    });
  };

  handleOnLogoUpdated = (data) => {
    const { data: original, isValid } = this.props.customization;

    this.props.setPartialState({
      data: {
        ...original,
        ...data,
      },
      isValid: isValid,
    });
  };

  handleOnSeriesDataChange = (event) => {
    const { data } = this.props.customization;

    this.props.setPartialState({
      data: {
        ...data,
        ...event.data,
      },
      isValid: true,
    });
  };

  handleOnSubmit = async () => {
    const { data } = this.props.customization;
    const { personalizar } = data.config || {};

    const body = {
      personalizar,
      series: data.series.filter((item) => item.action !== undefined),
    };

    await this.props.update(body, data.id);

    if (this.props.onComplete) {
      const { data: updated } = this.props.customization;

      this.props.onComplete(updated);
    }
  };

  handleOnCloseError = () => {
    this.props.resetError();
  };

  renderError = () => {
    const { error } = this.props.customization;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleOnCloseError}
        />
      </div>
    );
  };

  render() {
    const {
      data = {},
      data: { series = [] },
      isValid,
      busy,
      error,
      result,
    } = this.props.customization;

    if (busy && !data.rfc) {
      return <Loading />;
    }

    if (!busy && !data.rfc) {
      return <div>Debes subir tu CSD antes de personalizar tus comprobantes</div>;
    }

    return (
      <>
        {!!error && this.renderError()}

        <div className="py-3">
          <strong className="text-info">PERSONALIZAR</strong>
        </div>
        <div className="">
          <EmisorPdfCustomization
            data={!!data.config ? data.config.personalizar || {} : {}}
            emisor={{ ...data }}
            onFormDataChange={this.handleOnDataChange}
            onLogoUpdated={this.handleOnLogoUpdated}
          />
        </div>
        <div className="py-3">
          <strong className="text-info">SERIES</strong>

          <EmisorSeriesManager
            data={series || []}
            onFormDataChange={this.handleOnSeriesDataChange}
          />
        </div>

        {!!result && !!result.data && (
          <>
            <div className="pb-2">
              <span className="text-success">Actualizado por última vez el {result.data.updated_at}</span>
            </div>
          </>
        )}

        <div className="pb-5">
          <LoadingButton
            disabled={busy || !isValid}
            loading={busy}
            onClick={this.handleOnSubmit}
          >
            Guardar
          </LoadingButton>
        </div>
      </>
    );
  }
}

const mapState = (store) => {
  return { customization: store.app.emisores.customization };
};

const mapActions = (actions) => {
  return actions.app.emisores.customization;
};

export default connect(useStore, mapState, mapActions)(EmisorCustomization);
